import { useRef, useEffect } from "react";
import {
  faFileCirclePlus,
  faTrashCan,
  faSearch,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Stack } from "@vapor/react-material";
import Button from "@vapor/react-material/Button";
import { DefaultFiltersType } from "../types";
import { defaultFilters } from "../document-utils/DefaultFiltersInputs";
import { emptyPagesData } from "../DocumentsCostants";
import { useDocumentList } from "../../document-page/state/useDocumentList";

interface EmptyDocumentTableViewProps {
  documentsLength: number;
  documentFilterOption: string;
  searchValue: string;
  filters: DefaultFiltersType;
}

const EmptyDocumentTableView: React.FC<EmptyDocumentTableViewProps> = ({
  documentsLength,
  documentFilterOption,
  filters,
  searchValue,
}) => {
  const prevFiltersRef = useRef<DefaultFiltersType | null>(null);
  const areFiltersChanged = useRef(false);
  const { isFiltering } = useDocumentList();

  let emptyDoc;

  if (isFiltering) {
    emptyDoc = emptyPagesData.NO_RESULTS_FROM_FILTERS;
  } else if (documentFilterOption === "CESTINO") {
    emptyDoc = emptyPagesData.CESTINO;
  } else if (documentsLength === 0) {
    emptyDoc = emptyPagesData.NO_RESULTS_FROM_SEARCH; // If no documents
  }

  return (
    <Stack alignItems="center" spacing={1}>
      <FontAwesomeIcon
        color="#0090d1"
        icon={emptyDoc.icon}
        style={{
          width: "84px",
          height: "84px",
          marginBottom: "8px",
          color: "#9EAAB3",
        }}
      />
      <Typography color="primary.main" component="div" variant="titleSmall">
        {emptyDoc.title}
      </Typography>
      <Typography
        color="primary.textSubduedColor"
        component="div"
        variant="body"
      >
        {emptyDoc.desc}
      </Typography>
      {documentFilterOption === "CESTINO" ? (
        <div></div>
      ) : (
        <>
          <div style={{ height: "1px" }}></div>
          <Button variant="contained" size="medium">
            {documentFilterOption === "CESTINO"
              ? "Recupera documenti"
              : "Carica documento"}
          </Button>
        </>
      )}
    </Stack>
  );
};

export default EmptyDocumentTableView;
